module.exports = __webpack_public_path__ + "img/industryDesc.f3bb47d0.png";